<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-img
                :src="wtcImgInfo.roomImgRoute"
                @click="click"
                style="cursor: pointer"
        ></v-img>
    </div>
</template>

<script>

    export default {
        name: 'RoadMapPop',

        components: {
        },
        data: () => ({
            wtcImgInfo:{}
        }),
        mounted() {
            this.$nextTick(() => {
            })
        },
        created: function(){
            // 맨위로
            window.scrollTo(0,0);
            this.getImgList();
        },
        methods: {
            click(){
                window.close();
            },
            // 이미지
            getImgList(){
                return this.$store.dispatch("admin/getRoomImg", {roomId: 'WTC'})
                    .then((resp) => {
                        setTimeout(() => {

                            this.wtcImgInfo = resp.message[0];

                        }, 300)
                    })
                    .catch((err) => {
                    })
            },
        }

    }
</script>



